import React from 'react';
import styles from './AmbassadorPrograms.module.css';
import AlbirNatallia from "assets/images/AlbirRojasAndNatalia.png";
import { useTranslation, Trans } from 'react-i18next';

const AmbassadorPrograms = () => {
    const { t } = useTranslation();
    const cards = t('ambassadorPrograms.cards', { returnObjects: true }) as {
        title: string;
        text: string;
        url: string;
    }[];


    return (
    <div className={styles.ambassadorprogram}>
        <div className={styles['ambassadorprogram-wrapper']}>
       <h2 className={styles['ambassadorprogram-title']}>
            <span className={styles['programs-title-top']}> {t('ambassadorPrograms.titleTop')} </span>
            <span className={styles['programs-title-bottom']}> {t('ambassadorPrograms.titleBottom')} </span>
       </h2>
       <div className={styles['ambassadorprogram-content']}> 
       <div className={styles['ambassadorprogram-cards']}>
            {cards.map((card, index) => (
              <a key={index} href={card.url} target="_blank" rel="noreferrer" className={styles.card}>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </a>
            ))}
        </div>
        <div className={styles['ambassadorprogram-signature']}>
        <div className={styles['ambassadorprogram-image-wrapper']}>
            <div className={styles['border-wrapper']}>
                    <img className={styles['ambassadorprogram-signature__image']} src={AlbirNatallia} alt="Albir Rojas & Natallia" />
            </div>
        </div>
            <p className={styles['ambassadorprogram-signature__text']}>
                <Trans i18nKey="ambassadorPrograms.signatureText" components={{ br: <br /> }} />
            </p>
        </div>
        </div>  
    </div>
    </div>
    );
};

export default AmbassadorPrograms;